exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".score[data-v-70476b66]{color:#00c4aa;font-size:6.4vw;line-height:6.4vw;font-weight:700;margin-bottom:1.33333vw}.sub[data-v-70476b66]{font-size:3.2vw;color:#666}.float[data-v-70476b66]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:absolute;z-index:-1;width:100%;height:100%}", ""]);

// exports
